import { makeStyles } from '@alpha/ui-lib/theme';

export const useStyles = makeStyles(
  () => ({
    container: {
      maxWidth: '600px',
      minWidth: '580px',
      '& div[class^="APModal-header-"], div[class*=" APModal-header-"]': {
        borderBottom: 'none !important',
      },
    },
    wrapper: {
      padding: '0px !important',
      maxHeight: '80vh',
      overflowY: 'auto',
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      margin: 'auto 16px',
      marginRight: '40px', // So it will not cover the close button
      justifyContent: 'flex-start',
      '& h2': {
        fontWeight: '600',
        fontSize: '18px',
        lineHeight: '36px',
        position: 'relative',
      },
      '& p': {
        fontSize: '13px',
        color: '#000000BF',
      },
    },
    body: {
      borderRadius: '10px',
      border: '1px solid #eaeaea',
      padding: '16px',
      margin: 'auto 32px',
      marginTop: '16px',
      '&:not(:first-child)': {
        marginTop: '8px',
      },
      '& h3': {
        fontWeight: 600,
      },
      '& h6': {
        color: '#222222',
        fontSize: '16px',
        fontWeight: '300',
        lineHeight: '24px',
      },
      '& .errorMessage': {
        fontWeight: 'bold',
        paddingBottom: '20px',
      },
      '& .warning': {
        marginBottom: '0px',
      },
      '& .MuiTableCell-root.MuiTableCell-body': {
        padding: '8px 0px',
      },
    },
    message: {
      color: 'rgba(33, 37, 41, 0.5)',
      fontSize: '13px',
      margin: '0px',
    },
    buttonsContainer: {
      textAlign: 'right',
      margin: 'auto 32px',
      marginTop: '24px',
      display: 'flex',
      '& .closeButton': {
        fontWeight: 'bold',
      },
      '& .cancelButton': {
        background: '#F7F7F7',
        color: '#212529',
      },
      '& .submitButton': {
        marginLeft: '16px',
        width: 'auto',
        flex: '1',
      },
    },
    paddingBottom: {
      paddingBottom: '20px',
    },
    noDivider: {
      '& .MuiTableRow-root': {
        borderBottom: 'none',
      },
    },
    matchingTable: {
      '& td:first-of-type': {
        color: '#00000080',
      },
    },
    floatingIcon: {
      position: 'absolute',
      marginLeft: '-24px',
      marginTop: '4px',
    },
    vopWarning: {
      color: 'rgba(207, 117, 47, 0.1) !important',
      marginTop: '16px',
      '& .icon': {
        color: '#CF752F !important',
        fontWeight: '600 !important',
        alignSelf: 'start !important',
        marginTop: '4px',
      },
      '& .text': {
        fontWeight: '400 !important',
        color: '#CF752F !important',
      },
    },
    vopInfo: {
      color: '#3E8CC1 !important',
      marginTop: '16px',
      '& .icon': {
        color: '#3E8CC1 !important',
        fontWeight: '600 !important',
        alignSelf: 'start !important',
        marginTop: '4px',
      },
      '& .text': {
        fontWeight: '400 !important',
        color: '#3E8CC1 !important',
      },
    },
    continueWithoutUpdateButton: {
      justifyContent: 'right',
      color: '#cf752f',
      textDecoration: 'underline',
      backgroundColor: 'transparent',
      '&:hover': {
        background: 'rgba(207, 117, 47, 0.1)',
      },
    },
  }),
  { name: 'VOPConfirmationModal' },
);

export default useStyles;
